/**
 * Big Waster API
 * This is a Big Waster API.
 *
 * OpenAPI spec version: 1.0
 * Contact: terry.wong@futureimpactlab.com
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 *
 */

import ApiClient from '../ApiClient';
import SubmissionQueryResult from './SubmissionQueryResult';

/**
 * The SubmissionOutputSubmission model module.
 * @module model/SubmissionOutputSubmission
 * @version 1.0
 */
class SubmissionOutputSubmission {
    /**
     * Constructs a new <code>SubmissionOutputSubmission</code>.
     * @alias module:model/SubmissionOutputSubmission
     */
    constructor() { 
        
        SubmissionOutputSubmission.initialize(this);
    }

    /**
     * Initializes the fields of this object.
     * This method is used by the constructors of any subclasses, in order to implement multiple inheritance (mix-ins).
     * Only for internal use.
     */
    static initialize(obj) { 
    }

    /**
     * Constructs a <code>SubmissionOutputSubmission</code> from a plain JavaScript object, optionally creating a new instance.
     * Copies all relevant properties from <code>data</code> to <code>obj</code> if supplied or a new instance if not.
     * @param {Object} data The plain JavaScript object bearing properties of interest.
     * @param {module:model/SubmissionOutputSubmission} obj Optional instance to populate.
     * @return {module:model/SubmissionOutputSubmission} The populated <code>SubmissionOutputSubmission</code> instance.
     */
    static constructFromObject(data, obj) {
        if (data) {
            obj = obj || new SubmissionOutputSubmission();

            if (data.hasOwnProperty('submission')) {
                obj['submission'] = SubmissionQueryResult.constructFromObject(data['submission']);
            }
        }
        return obj;
    }


}

/**
 * @member {module:model/SubmissionQueryResult} submission
 */
SubmissionOutputSubmission.prototype['submission'] = undefined;






export default SubmissionOutputSubmission;

